/**
 * Fila de refresh compartilhada — correção do defeito do Flutter, onde `_isRefreshing` retorna
 * `null` para chamadas paralelas e derruba a sessão. Aqui, N chamadas concorrentes em 401
 * aguardam a MESMA promise de refresh; só a primeira dispara `POST /auth/refresh`.
 */
export function createRefreshQueue(refresh: () => Promise<void>): () => Promise<void> {
  let inFlight: Promise<void> | null = null;

  return function runRefresh(): Promise<void> {
    inFlight ??= refresh().finally(() => {
      inFlight = null;
    });
    return inFlight;
  };
}
